module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/attractions-nature-c7c2c224341b1e72df74916e03e12222.jpg";